
export const mutations = {
    setUsuarioLogadoNoSistema(state, request) {
        state.usuarioLogadoNoSistema = request;
    },
    setPerfil(state, request) {
        state.perfil = request;
    },
    setMatriculas(state, request) {
        state.matriculas = request;
    },
    setModulos(state, request) {
        state.modulos = request;
    },
};
